import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as ALBUM_MEDIA_TYPE} from '../creators/album.media';

export function* createSuccess(action) {
    try {
        yield put({type: "ALBUM_MEDIAS_ADD", data : action.payload});
        yield put({type: "MEDIAS_ADD", data : action.payload});
        yield put({type: "ALBUM_MEDIAS_MULTI_ADD", data : action.payload});
        yield put({type: "USER_ALBUMS_ADD_MEDIA", data : action.payload});
    } catch (error) {

    }
}

export function* watchAlbumMedia() {
    yield takeEvery(ALBUM_MEDIA_TYPE.CREATE_SUCCESS, createSuccess);
}

export default watchAlbumMedia;

